import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { AccumulativeShadows, RandomizedLight, Center, Environment, OrbitControls } from '@react-three/drei'

const Colors = [
  ['LightPink', '#FFB6C1'],
  ['Pink', '#FFC0CB'],
  ['HotPink', '#FF69B4'],
  ['DeepPink', '#FF1493'],
  ['PaleVioletRed', '#DB7093'],
  ['LightSalmon', '#FFA07A'],
  ['Coral', '#FF7F50'],
  ['Tomato', '#FF6347'],
  ['OrangeRed', '#FF4500'],
  ['IndianRed', '#CD5C5C'],
  ['MistyRose', '#FFE4E1'],
  ['Blush', '#DEB2B2'],
  ['LightCoral', '#F08080'],
  ['RosyBrown', '#BC8F8F'],
  ['Salmon', '#FA8072'],
  ['DarkSalmon', '#E9967A'],
  ['Orchid', '#DA70D6'],
  ['LavenderBlush', '#FFF0F5'],
  ['PalePink', '#F9CCCA'],
  ['CarnationPink', '#FFA6C9'],
  ['BubbleGum', '#FFC1CC'],
  ['CherryBlossomPink', '#FFB7C5'],
  ['FlamingoPink', '#FC8EAC'],
  ['FuchsiaPink', '#FF77FF'],
  ['Raspberry', '#E30B5C'],
  ['Rose', '#FF007F'],
  ['WatermelonPink', '#FFC6C6'],
  ['TeaRose', '#F4C2C2'],
  ['Crimson', '#DC143C'],
  ['Rouge', '#C82536'],
  ['Vermilion', '#E34234'],
  ['BrickRed', '#CB4154'],
  ['Maroon', '#800000'],
  ['Cinnamon', '#D2691E'],
  ['Hibiscus', '#B43757'],
  ['AmaranthRed', '#F4364C'],
  ['BlushMakeup', '#BC544B']
];

const seed = Math.floor(Math.random() * 250);

const shuffle = [
  1, 22, 13, 8, 22, 2, 27, 34, 22, 4, 4, 7, 32, 2, 10, 22, 12, 26, 0, 2, 29, 16, 26, 17, 32, 27, 23, 35, 13, 14, 0, 16, 4, 35, 8, 1, 28, 24, 12, 31, 1, 26, 5,
  31, 25, 32, 7, 14, 9, 16, 15, 16, 23, 9, 9, 28, 12, 3, 30, 35, 14, 35, 16, 7, 12, 22, 5, 15, 15, 28, 24, 34, 3, 17, 30, 4, 6, 1, 29, 21, 14, 6, 9, 35, 1, 2,
  35, 1, 1, 28, 22, 5, 29, 32, 7, 31, 25, 7, 33, 24, 1, 1, 18, 4, 30, 34, 23, 34, 2, 33, 8, 22, 11, 19, 14, 25, 19, 29, 23, 20, 27, 15, 5, 29, 9, 18, 6, 9, 5,
  19, 11, 0, 16, 12, 35, 34, 35, 4, 5, 4, 24, 36, 12, 14, 30, 29, 20, 19, 25, 10, 15, 35, 36, 22, 25, 17, 3, 3, 17, 30, 7, 8, 8, 31, 26, 15, 5, 21, 21, 12, 27,
  33, 26, 24, 9, 19, 14, 1, 10, 32, 36, 27, 10, 28, 35, 22, 7, 26, 30, 35, 0, 31, 23, 7, 16, 3, 9, 5, 24, 2, 5, 5, 25, 33, 18, 29, 26, 33, 36, 31, 34, 21, 2,
  25, 20, 24, 3, 9, 8, 31, 36, 30, 16, 19, 9, 31, 2, 24, 10, 17, 14, 27, 7, 32, 32, 27, 20, 4, 11, 31, 18, 8, 34, 21, 33, 10, 2, 4, 32, 25, 2, 16, 6, 3, 11, 20,
  7, 5, 17, 25, 24, 36, 8, 14, 13, 21, 26, 27, 32, 6, 4, 11, 3, 7, 27, 18, 32, 3, 10, 2, 11, 9, 22, 22, 16, 16, 14, 16, 11, 12, 28, 6, 10, 2, 17, 24, 16, 1, 15,
  23
];

let curColor = '';
let wrongClicks = 0;
let rightClicks = 0;

export default function App() {
  return (
    <Canvas shadows camera={{ position: [0, 0, 4.5], fov: 50 }}>
      <group position={[0, -0.65, 1]}>
        <Sphere
          onPointerDown={(event) => {
            let score = parseInt(jQuery('#theScore').val());
            if (curColor === 'Pink') {
              window.jQuery('#status').append('<div>YAY that is ' + curColor + '!</div>');
              rightClicks++;
              score = score +5;
            }
            else {
              window.jQuery('#status').append('<div>SORRY, that is ' + curColor + '!</div>');
              wrongClicks++;
              score--;
            }
            jQuery('#theScore').val(score);
            var count = window.jQuery('#status > div').length;
            if ( count > 15 ) {
              window.jQuery('#status > div').first().remove();
            }
            window.jQuery('#score').html('Score: ' + score);
            if ( score >= 10 ) {
              window.jQuery('#prize').addClass('active');
            }
          }}
        />
        <AccumulativeShadows temporal frames={200} color="purple" colorBlend={0.5} opacity={1} scale={10} alphaTest={0.85}>
          <RandomizedLight amount={8} radius={5} ambient={0.5} position={[5, 3, 2]} bias={0.001} />
        </AccumulativeShadows>
      </group>
      <Env />
      <OrbitControls autoRotate autoRotateSpeed={4} enablePan={false} enableZoom={false} minPolarAngle={Math.PI / 2.1} maxPolarAngle={Math.PI / 2.1} />
    </Canvas>
  )
}

function Sphere(props) {
  const ref = useRef()
  useFrame((state) => {
    const v1 = (seed + Math.floor(state.clock.getElapsedTime() * 5)) % 300
    const color = Colors[shuffle[v1]][1]
    curColor = Colors[shuffle[v1]][0]
    ref.current.color.set(color)
  })

  return (
    <Center top>
      <mesh castShadow {...props}>
        <sphereGeometry args={[0.75, 80, 80]} />
        <meshStandardMaterial ref={ref} color="#ffffff" metalness={1} roughness={1} />
      </mesh>
    </Center>
  )
}

function Env() {
  return <Environment preset="sunset" background blur="0.65" />
}
